import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { StoreService } from '@morningstar/shared/base/base-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CheckIns } from './check-ins/check-ins';
import { DayOfWeekCheckIns } from './day-of-week-check-ins/day-of-week-check-ins';
import * as moment from 'moment';
import { CheckInsSelectors } from './check-ins.selectors';
import { MomentFormat } from '@morningstar/shared/models';

@Injectable()
export class CheckInsService extends StoreService {

  constructor(protected httpClient: HttpClient,
              snackbar: MatSnackBar,
              @Inject('API_BASE_URL') baseUrl) {
    super(httpClient, baseUrl, snackbar);
  }

  getCheckIns(location: string, date: Date) {
    const endpoint = `dashboard/check-ins/${location}/date/${moment(date).format(MomentFormat.datetime)}`;

    this.read<CheckIns>(CheckInsSelectors.checkIns, endpoint, 'check-ins')
        .subscribe();
  }

  getDayOfWeekCheckIns(location: string) {
    const endpoint = `dashboard/check-ins/${location}/day-of-week`;

    this.readList<DayOfWeekCheckIns>(CheckInsSelectors.dayOfWeekCheckIns, endpoint, 'check-ins')
        .subscribe();
  }

  getMonthlyCheckIns(location: string) {
    const endpoint = `dashboard/check-ins/${location}/monthly`;

    this.readList<DayOfWeekCheckIns>(CheckInsSelectors.monthly, endpoint, 'check-ins')
        .subscribe();
  }
}